import { getCustomerPage, exportExcel } from '@/api/home/customer'
import { useExportExcel } from '@/hooks'
export class CustomerController {
  static async page (params: {pageNum: number, pageSize: number, nickname: string}) {
    const { data } = await getCustomerPage(params)
    return {
      data: data.records,
      sum: data.total
    }
  }

  static async exportExcel () {
    const data = await exportExcel()
    useExportExcel(data as any, '用户')
  }
}
